type Glob = {
	default: {
		render: Function;
		$$render: Function;
	},
	metadata: {
		title: string;
		published_time: string;
		og: {
			title: string;
			description: string;
		}
	}
}

export const globs = import.meta.glob<Glob>('./**/*.md', {
	eager: true,
})

export const globByFullPathname = new Map<string, Glob>()
for (let [pathname, module] of Object.entries(globs)) {
	pathname = pathname.replace("./", "").replace(".md", "/")

	globByFullPathname.set(pathname, module)
}